var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsSeDelivery = function SvgNnIconFlagsSeDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-SE-delivery_svg__Lager_15",
    "data-name": "Lager 15",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-SE-delivery_svg__cls-3{fill:#ffd500}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "#006dd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4.25h6.66v33.31H15.4z",
    className: "nn-icon-flags-SE-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 13.58h49.97v6.66H.25z",
    className: "nn-icon-flags-SE-delivery_svg__cls-3"
  })));
};
export default SvgNnIconFlagsSeDelivery;